import React from 'react';
import { CheckCircle, AlertCircle, Info } from 'lucide-react';

function AlertModal({
  isOpen,
  onClose,
  type = 'info',
  message,
  confirmText = '확인',
  cancelText,
  onConfirm,
}) {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  const iconConfig = {
    success: {
      bg: 'bg-teal-100',
      icon: <CheckCircle className="w-5 h-5 text-teal-600" />,
    },
    error: {
      bg: 'bg-red-100',
      icon: <AlertCircle className="w-5 h-5 text-red-600" />,
    },
    info: {
      bg: 'bg-blue-100',
      icon: <Info className="w-5 h-5 text-blue-600" />,
    },
  };

  const config = iconConfig[type] || iconConfig.info;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-sm w-full p-6 animate-in fade-in zoom-in duration-200">
        <div className="flex flex-col items-center text-center">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-3 ${config.bg}`}>
            {config.icon}
          </div>
          <p className="text-gray-800 font-medium mb-5 whitespace-pre-wrap">{message}</p>
          {cancelText ? (
            <div className="flex gap-3 w-full">
              <button
                onClick={onClose}
                className="flex-1 py-3 rounded-lg font-semibold transition-colors bg-gray-100 hover:bg-gray-200 text-gray-700"
              >
                {cancelText}
              </button>
              <button
                onClick={handleConfirm}
                className="flex-1 py-3 rounded-lg font-semibold transition-colors bg-teal-500 hover:bg-teal-600 text-white"
              >
                {confirmText}
              </button>
            </div>
          ) : (
            <button
              onClick={handleConfirm}
              className={`w-full py-3 rounded-lg font-semibold transition-colors ${
                type === 'success'
                  ? 'bg-teal-500 hover:bg-teal-600 text-white'
                  : type === 'error'
                  ? 'bg-gray-100 hover:bg-gray-200 text-gray-800'
                  : 'bg-teal-500 hover:bg-teal-600 text-white'
              }`}
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default AlertModal;